import { defineWidgetCore } from "../../widgetDefinition";
import { resolveTemplate } from "../../Utils/resolveTemplate";
import type { PieChartComponentSpec, WidgetResponseSpec } from "../../Processing/types";
import { buildPieConfig } from "../../Processing/buildPieConfig";
import { renderPie } from "../../PDF/renderers/piePdfRenderer";

const EMPTY_RESPONSE: WidgetResponseSpec = { widget_id: "", series: [] };

export const pieCore = defineWidgetCore<PieChartComponentSpec>({
  process(spec, response) {
    const s = spec;
    const chart = buildPieConfig(s, response ?? EMPTY_RESPONSE);
    return { type: "pie_chart", spec: s, chart };
  },
  pdf: {
    capture: "highcharts",
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "pie_chart") return null;
      const rawTitle = processed.spec.display.title;
      return {
        type: "pie_chart",
        title: rawTitle == null ? null : resolveTemplate(rawTitle, slicerValues).resolved,
        summary: null,
      };
    },
    render({ id, snapshot, rect, scale, chartImages }) {
      if (snapshot.type !== "pie_chart") return null;
      return renderPie(snapshot, rect, scale, chartImages[id]);
    },
  },
});
